<template>
  <!-- 面包屑 -->
  <!-- <div class="cmp-bread-box" 
    :class="{'hasLine': $route.meta.hasLine, 
    'dark': $store.state.app.breadStyleType==='1' || $route.meta.breadStyleType === '1', 
    'gray': $store.state.app.breadStyleType==='2' || $route.meta.breadStyleType === '2', 
    'brown': $store.state.app.breadStyleType==='3' || $route.meta.breadStyleType === '3'}"  -->
  <div class="cmp-bread-box gray" :class="{'pc': !_isMobile, 'mobile': _isMobile}"
    v-if="breadList && breadList.length && $store.state.app.platform!='minipro'">
    <!-- breadStyleType ''白色文字 1黑色文字 2灰色背景 -->
    <div class="cmp-bread">
      <!-- <v-breadcrumbs :items="breadList" large>
        <template v-slot:divider>
          <v-icon>mdi-chevron-right</v-icon>
        </template>
      </v-breadcrumbs> -->

      <el-breadcrumb separator-class="el-icon-arrow-right">
        <!-- <el-breadcrumb-item :to="{ path: '/' }">首页</el-breadcrumb-item> -->
        <el-breadcrumb-item v-for="(item, index) in breadList" :key="index" :to="item.href">
          <!-- <i class="icon-dot" v-if="index===0"></i> -->
          {{item.text}}
        </el-breadcrumb-item>
      </el-breadcrumb>
    </div>
  </div>
</template>

<script>
export default {
  watch: {
    $route: {
      handler(Val) {
        return this.getBreadcrumb()
      },
      immediate: true
    },
    '$store.state.app.breadcumbList': function(newVal) {
      if(this.$route.meta.useStore) {
        this.breadList = newVal
      }
    }
  },
  data() {
    return {
      breadList: [], // 路由集合
      items: [
        {
          text: '首页',
          disabled: false,
          href: '/'
        },
        {
          text: '列表',
          disabled: false,
          href: 'demo3'
        },
        {
          text: '详情',
          disabled: true,
          href: 'breadcrumbs_link_2'
        }
      ]
    }
  },
  methods: {
    getBreadcrumb() {
      // matched：返回一个数组，包含当前路由的所有嵌套路径片段的路由记录 。
      // console.log(11,this.$route)
      // this.breadList = this.$route.meta.breadList

      // 是否采用状态中的面包屑数据
      if(this.$route.meta.useStore) {
        this.breadList = this.$store.state.app.breadcumbList
      } else if (this.$route.query.breadType) {
        // 固定分类详情 todo 优化
        let arr = JSON.parse(JSON.stringify(this.$route.meta.breadList))
        arr.push(this.$route.meta.breadType[this.$route.query.breadType])
        this.breadList = arr
      } else {
        this.breadList = this.$route.meta.breadList
      }

      // 固定分类详情 todo 优化
      // if(this.$route.query.breadType) {
      //   this.breadList.push(this.$route.meta.breadType[this.$route.query.breadType])
      // }
    }
  }
};
</script>

<style lang="scss" scoped>
.cmp-bread-box {
  &.pc {
    .cmp-bread {
      padding: 30px 0;
      width: $minWidth;
      margin: 0 auto;
      border-bottom: solid 1px rgba(#000000, 0.1);
    }
  }
  &.mobile {
    .cmp-bread {
      padding: 10px 15px;
      margin: 0 auto;
      border-bottom: solid 1px rgba(#000000, 0.1);
    }
  }

  &.hasLine {
    border-top: solid 1px rgba(#121100, 0.2);;
  }
  
  .cmp-bread {
    position: relative;
    
    /deep/ .el-breadcrumb {
      line-height: 30px;
      font-size: 16px;
      position: absolute;
      left: 0;
      top: 56px;
      z-index: 2;
      .icon-dot {
        display: inline-block;
        width: 17px;
        height: 14px;
        // background: url(~@images/icon-bread-white.png) no-repeat center center;
        background-size: 100% 100%;
      }
      .el-breadcrumb__inner {
        font-size: 18px;
        color: rgba($color: #fff, $alpha: 0.8);
      }
      .el-breadcrumb__inner.is-link, 
      .el-breadcrumb__inner a {
        // color: #292423;
        color: #fff;
        font-weight: normal;
      }
      .el-icon-arrow-right:before {
        color: #fff;
      }
    }
  }
  &.dark,
  &.gray {
    // padding-top: 50px;
    .cmp-bread {
      /deep/ .el-breadcrumb {
        position: relative;
        left: 0;
        top: 0;
        .icon-dot {
          // background: url(~@images/icon-bread.png) no-repeat center center;
          background-size: 100% 100%;
        }
        .el-breadcrumb__inner {
          color: rgba($color: #3D3D3D, $alpha: 0.6);
        }
        .el-breadcrumb__inner.is-link, 
        .el-breadcrumb__inner a {
          color: #3D3D3D;
        }
        .el-icon-arrow-right:before {
          color: #3D3D3D;
        }
      }
    }
  }
  &.gray {
    // background: #f6f6f6;
  }
  &.brown {
    /deep/ .el-breadcrumb {
      color: #5D4339;
      .icon-dot {
        // background: url(~@images/icon-bread-brown.png) no-repeat center center;
        background-size: 100% 100%;
      }
      .el-breadcrumb__inner {
        font-size: 18px;
        color: rgba($color: #5D4339, $alpha: 0.8);
      }
      .el-breadcrumb__inner.is-link, 
      .el-breadcrumb__inner a {
        color: #5D4339;
      }
      .el-icon-arrow-right:before {
        color: #5D4339;
      }
    }
  }
}


</style>
